import { gql, QueryResult, QueryTuple, useLazyQuery, useQuery } from '@apollo/client';

import { MFACodeSentEnum } from '../../../../constants/enums/MfaCodeSentEnum';
import { getPolices } from '../../../../utils/gqlPolicesUtil';

export const VALIDATE_MFA_CODE = gql`
  query ValidateMFACode($code: String!, $type: MFACodeSentTypeEnum!) {
    validateMFACode(code: $code, type: $type) {
      success
      message
      attempts
      nextAttempt
    }
  }
`;

export interface IValidateMFACodeParams {
  code: string;
  type: MFACodeSentEnum;
}

export interface IValidateMFACodeResponse {
  validateMFACode: {
    success: boolean;
    message?: string;
    attempts?: number;
    nextAttempt?: string;
  };
}

export const useLazyValidateMFACode = (
  fromCache?: boolean,
): QueryTuple<IValidateMFACodeResponse, IValidateMFACodeParams> =>
  useLazyQuery<IValidateMFACodeResponse, IValidateMFACodeParams>(VALIDATE_MFA_CODE, {
    ...getPolices(fromCache),
  });

export const useQueryValidateMFACode = (
  code: string,
  type: MFACodeSentEnum,
  fromCache?: boolean,
): QueryResult<IValidateMFACodeResponse, IValidateMFACodeParams> =>
  useQuery<IValidateMFACodeResponse, IValidateMFACodeParams>(VALIDATE_MFA_CODE, {
    variables: { code, type },
    ...getPolices(fromCache),
  });
